/**
 * FEAT-087 / S-383 — pure formatting for the Analytics "where the time goes"
 * chart. Split out so it is testable without the view's Vite- and
 * Clerk-dependent imports, the same way ui-state.ts and queue-groups.ts are.
 */

/** `ai_researching` → `Scout`, so the chart reads as the pipeline does. */
export const PHASE_AGENT: Record<string, string> = {
  ai_researching: "Scout",
  ai_outlining: "Librarian",
  ai_drafting: "Writer",
  ai_factchecking: "Auditor",
  ai_editing: "Editor",
  ai_optimizing: "SEO Optimizer",
  ai_imaging: "Art Director",
  ai_publishing: "Publisher",
  human_review: "Your review",
};

/** Hours below a day, days above — "41.0h" is harder to read than "1.7d". */
export function formatHours(h: number): string {
  if (h >= 24) return `${Math.round((h / 24) * 10) / 10}d`;
  if (h >= 1) return `${Math.round(h * 10) / 10}h`;
  return `${Math.round(h * 60)}m`;
}
